import { Component, Input, ContentChild, Output, EventEmitter, OnInit } from '@angular/core';

export enum STATUS {
  UP_DOWN = 0,
  UP = 1,
  DOWN = 2
}

@Component({
  selector: 'app-arrow-label',
  templateUrl: './sort-arrows.component.html',
  styleUrls: ['./sort-arrows.component.scss']
})
export class SortArrowsComponent {

  @ContentChild('child') child;
  @Output() sort: EventEmitter<number> = new EventEmitter<number>();
  @Input() set value(value: number) {
    if (value || value === 0) {
      this.status = value;
    }
  }

  status = 0;

  public nextStatus(): void {
    const mapNextValue = {
      [STATUS.UP_DOWN]: STATUS.UP,
      [STATUS.UP]: STATUS.DOWN,
      [STATUS.DOWN]: STATUS.UP_DOWN
    };
    const newValue = mapNextValue[this.status];
    this.status = newValue;
    this.sort.emit(this.status);
  }

}
